import React from 'react'
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import { LAYOUT_OBJECT_TYPES } from './layoutTerminology'

const verticalMenuProps = {
  MenuListProps: {
    sx: {
      '&&': {
        alignItems: 'stretch',
        display: 'flex',
        flexDirection: 'column',
      },
    },
  },
}

const verticalMenuItemSx = {
  '&&': {
    display: 'flex',
    flex: '0 0 auto',
    justifyContent: 'flex-start',
    textAlign: 'left',
    width: '100%',
  },
}

const ObjectTypeDropdown = ({ selectedObjectType, setSelectedObjectType }) => {
  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel id="object-type-label">Tab</InputLabel>
      <Select
        labelId="object-type-label"
        value={selectedObjectType}
        onChange={(e) => setSelectedObjectType(e.target.value)}
        label="Tab"
        MenuProps={verticalMenuProps}
        sx={{ '&& .MuiSelect-select': { textAlign: 'left' } }}
      >
        {LAYOUT_OBJECT_TYPES.map((type) => (
          <MenuItem key={type.value} value={type.value} sx={verticalMenuItemSx}>
            {type.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default ObjectTypeDropdown
